import { render, staticRenderFns } from "./MessageThreadsView.vue?vue&type=template&id=dfda37d8&scoped=true&"
import script from "./MessageThreadsView.vue?vue&type=script&lang=ts&"
export * from "./MessageThreadsView.vue?vue&type=script&lang=ts&"
import style0 from "./MessageThreadsView.vue?vue&type=style&index=0&id=dfda37d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfda37d8",
  null
  
)

export default component.exports